import { useCallback } from 'react';

import { useQueryParamValue } from 'src/app/shared/hooks/location';
import type { ShareChannel } from 'src/app/shared/hooks/share';

export function useGetTrackingData(
	petitionUserId: { id: string },
	currentUserId: string | undefined,
	petitionId: string,
) {
	const sourceLocation = useQueryParamValue('source_location');

	return useCallback(
		(_channel: ShareChannel) => ({
			location: 'mobileNativeShare',
			view_context: 'share_petition',
			own_petition: petitionUserId.id === currentUserId,
			context: 'share_petition',
			petition_id: `petition_${petitionId}`,
			source_location: sourceLocation,
		}),
		[currentUserId, petitionId, petitionUserId, sourceLocation],
	);
}
